/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Preset_Load_Title_HintInputs */



/**
* | output |
* | --- |
* | "Load a saved preset" |
*
* @param {Audio_Description_Export_Preset_Load_Title_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_preset_load_title_hint = /** @type {((inputs?: Audio_Description_Export_Preset_Load_Title_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Preset_Load_Title_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Charger un préréglage enregistré")
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine gespeicherte Voreinstellung laden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Carica un preset salvato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузите сохраненный пресет")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargar un ajuste preestablecido guardado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("加载已保存的预设")
	if (locale === "ja") return /** @type {LocalizedString} */ ("保存したプリセットを読み込む")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक सहेजा हुआ प्रीसेट लोड करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregar uma predefinição salva")
	return /** @type {LocalizedString} */ ("Load a saved preset")
});